"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentInvoiceStatusCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../utils/classFunctions");
require("./index.scss");
const className = 'allotment-invoice-status-cell';
const statusMap = {
    pending: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/StatusCell:pending', defaultMessage: 'Pending' })),
    overDeadline: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/StatusCell:overDeadline', defaultMessage: 'Over deadline' })),
    paid: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/StatusCell:paid', defaultMessage: 'Paid' })),
    overpaid: react_1.default.createElement(react_1.default.Fragment, null, "Overpaid"),
};
const AllotmentInvoiceStatusCell = (props) => {
    const { status } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        status,
    ]);
    return (react_1.default.createElement("div", { className: classNames }, statusMap[status]));
};
exports.AllotmentInvoiceStatusCell = AllotmentInvoiceStatusCell;
//# sourceMappingURL=index.js.map